<template>
  <div class="admin-sidebar">
    <div class="sidebar-header">
      <span class="admin-logo">ShopT</span>
    </div>
    <nav class="sidebar-nav">
      <ul>
        <li>
          <router-link to="/admin/products">
            <i class="fas fa-box"></i> Products
          </router-link>
        </li>
        <li>
          <router-link to="/admin/orders">
            <i class="fas fa-shopping-cart"></i> Orders
          </router-link>
        </li>
        <li>
          <router-link to="/admin/discounts">
            <i class="fas fa-percent"></i> Discounts
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>

export default {
  name: 'Navbar',
  data() {
    return {};  // Burada boş bir nesne döndürüyoruz.
  },
  computed: {

  },
  methods: {

  }
};
</script>

<style scoped>
/* Sidebar Styles */
.admin-sidebar {
  width: 250px;
  background-color: #000;
  border-right: 2px solid purple;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #333;
}

.admin-logo {
  color: #fff;
  font-weight: 1000;
  font-size: 1.5rem;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-nav li {
  margin: 0;
}

.sidebar-nav a {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #ccc;
  text-decoration: none;
  transition: all 0.3s;
  border-left: 3px solid transparent;
}

.sidebar-nav a i {
  margin-right: 10px;
  width: 20px;
  text-align: center;
}

.sidebar-nav a:hover, .sidebar-nav a.active {
  background-color: rgba(128, 0, 128, 0.2);
  color: #fff;
  border-left: 3px solid purple;
}
</style>
